import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MibSwitchComponent } from '@medinbox/angular';

/**
 * One setting on a row: what it is, what it does, and the library's switch on the right.
 *
 * The row is the control, not a container holding one: the label sits inside the switch's own
 * button, so a click anywhere on the row flips it and a host can paint a hover band across it.
 */
@Component({
  selector: 'mai-toggle-row',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MibSwitchComponent],
  templateUrl: './toggle-row.html',
  // No frame of its own: the room around the row belongs inside the button, or it answers no click.
  host: { class: 'block' },
})
export class ToggleRow {
  readonly label = input.required<string>();
  /** One short line under the label. Without it the row is just the label. */
  readonly description = input<string>();
  readonly checked = input.required<boolean>();
  /** Locks the switch while the host's write is in flight. */
  readonly pending = input(false);

  /** Emits the state asked for — the opposite of the current one. */
  readonly checkedChange = output<boolean>();
}
